module.exports = __webpack_public_path__ + "static/media/Hausmart_logo_text.e480dfdd.svg";